import script from "./InformeInterForm.vue?vue&type=script&setup=true&lang=js"
export * from "./InformeInterForm.vue?vue&type=script&setup=true&lang=js"

import "./InformeInterForm.vue?vue&type=style&index=0&id=9ca26966&scoped=true&lang=css"
import "@/assets/css/microfono.css?vue&type=style&index=1&id=9ca26966&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ca26966"]])

export default __exports__